import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { UserDataService } from 'src/app/providers/userData/user-data.service';

/** AQAR workspace: IQAC admins and Criteria Coordinators. */
@Injectable({
	providedIn: 'root'
})
export class AqarAccessGuard implements CanActivate {
	constructor(public userDataService: UserDataService, public router: Router) {}

	async canActivate(): Promise<boolean | UrlTree> {
		const roles: string[] = (await this.userDataService.getLoggedInUserRole()) || [];
		if (roles.includes('IQAC_ADMIN') || roles.includes('CRITERIA_COORDINATOR')) {
			return true;
		}
		return this.router.parseUrl('/home');
	}
}
